import { Component } from "@angular/core";

@Component({
  selector: "toolbox-messaging-colors",
  templateUrl: "./messaging-colors.component.html",
  styleUrls: ["./messaging-colors.component.scss"],
})
export class MessagingColorsComponent { }
